import Swal from 'sweetalert2'
import i18n from '@/i18n'

export function confirmModal(confirmButtonText, text) {
  return Swal.fire({
    title: i18n.t('swal.confirm-action'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#f46a6a',
    cancelButtonColor: '#9b9b9b',
    cancelButtonText: i18n.t('message.cancel'),
    confirmButtonText,
    text,
  })
}

export function confirmModalSuccess(confirmButtonText, text) {
  return Swal.fire({
    title: i18n.t('swal.confirm-action'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#34c38f',
    cancelButtonColor: '#9b9b9b',
    cancelButtonText: i18n.t('message.cancel'),
    confirmButtonText,
    text,
  })
}

export function formErrorModal(message = 'Certains de vos formulaires ne respectent pas les modalités') {
  Swal.fire('Attention', message, 'warning')
}
